import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { v4 as uuidv4 } from "uuid";
import { queryAllByAttribute } from "@testing-library/react";

export default function DayPicker({ name, value, onClick, width}) {
    const [isCalendarVisible, setIsCalendarVisible] = useState(false);
    const datePickerRef = useRef(null);
    const calendarRef = useRef(null);
	const dateInput = useRef(null);
	const calendarDiv = useRef();

	/*
    const handleOutsideClick = (event) => {
        if (event.target.classList.contains("react-calendar") && !datePickerRef.current.contains(event.target)) {
            setIsCalendarVisible(false);
        }
    };
	*/
	
    const handleOutsideClick = (event) => {
        // if(event.target.contains(datePickerRef.current)) {
        //     setIsCalendarVisible(false);
        // }
		if(!datePickerRef.current.contains(event.target)) {
            setIsCalendarVisible(false);
        }
    };

    const handleEscPress = (event) => {
        if (event.keyCode === 27) {
            setIsCalendarVisible(false);
        }
    };

    useEffect(() => {
        // 다른 곳 클릭 시 닫음
        document.addEventListener("click", handleOutsideClick, true);
        document.addEventListener("keydown", handleEscPress, true);
        return () => {
            document.removeEventListener("click", handleOutsideClick, true);
            document.removeEventListener("keydown", handleEscPress, true);
        };
    }, []);

    const onClickDay = (data) => {
        onClick(formatChange(data));
        setIsCalendarVisible(false);
    };

    const formatChange = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const formatted = `${year}-${month}-${day}`;
        return formatted;
    };
	
	useEffect(() => {
		// 상위의 테이블(정확히는 테이블을 감싸는 DIV)이 scroll이 있으면 스크롤 했을때 달력의 위치가 이상해짐.
		// 달력이 보여질때 위치를 계산해서 다시 설정.
		if(isCalendarVisible) {
			let dom = calendarDiv.current;
			let calTop = null;
			let calLeft = null;
			while(true) {
				dom = dom.parentElement ? dom.parentElement : null;
				if(dom === null || dom.tagName.toLowerCase() === "html") break;

				if(calTop === null && dom?.scrollTop && dom.scrollTop > 0) {
					calTop = (getComputedStyle(calendarDiv.current).top.replace("px", "")) * 1 - dom.scrollTop;
				}
				if(calLeft === null && dom?.scrollLeft && dom?.scrollLeft > 0) {
					calLeft = (getComputedStyle(calendarDiv.current).left.replace("px", "")) * 1 - dom.scrollLeft;
				}
				if(calTop !== null && calLeft !== null) break;
			}
			if(calTop !== null) {
				calendarDiv.current.style.top = calTop + "px";
			}
			if(calLeft !== null) {
				calendarDiv.current.style.left = calLeft + "px";
			}
		}

	}, [isCalendarVisible])

    return (
        <div ref={datePickerRef}>
            <input
                autoComplete="off"
                id={uuidv4()}
                type="text"
                name={name}
                value={value || "YYYY-MM-DD"}
                onClick={() => setIsCalendarVisible(true)}
                readOnly
                className="basic-input"
				ref={dateInput}
                style={{width : width}}
            />
            {isCalendarVisible && (
            <div ref={calendarRef} id={uuidv4()}>
                <div style={{ position: "absolute", width: "350px",zIndex:"999999"}} ref={calendarDiv}>
                    <Calendar onClickDay={(data) => onClickDay(data)}/>
                </div>
            </div>
            )}
        </div>
    );
}
